export default __webpack_public_path__ + "static/media/2a34f1f8-d701-4949-b12d-133c1c2636eb.84210de9.woff";